import React, { useCallback } from 'react';
import CustomBadge from 'components/ui/custom-badge';
import { useTranslation } from 'react-i18next';
import { PremiumDueResponseDtoNocStatusEnum } from 'libs/pinnacle-sdk';

interface NocStatusIndicatorProps {
  status: PremiumDueResponseDtoNocStatusEnum;
}
const NocStatusIndicator: React.FC<NocStatusIndicatorProps> = ({ status }) => {
  const { t } = useTranslation();
  const getNocStatusConfig = useCallback(
    (status: PremiumDueResponseDtoNocStatusEnum) => {
      switch (status) {
        case PremiumDueResponseDtoNocStatusEnum.NocIssued:
          return {
            bg: 'bg-blue-100',
            text: 'text-blue-600',
            label: PremiumDueResponseDtoNocStatusEnum.NocIssued,
          };
        case PremiumDueResponseDtoNocStatusEnum.NocDue:
          return {
            bg: 'bg-red-100',
            text: 'text-red-600',
            label: PremiumDueResponseDtoNocStatusEnum.NocDue,
          };
        case PremiumDueResponseDtoNocStatusEnum.Paid:
          return {
            bg: 'bg-green-100',
            text: 'text-green-600',
            label: PremiumDueResponseDtoNocStatusEnum.Paid,
          };
        default:
          return {
            bg: 'bg-gray-100',
            text: 'text-gray-600',
            label: status,
          };
      }
    },
    [t]
  );

  const config = getNocStatusConfig(status);

  return (
    <CustomBadge
      label={config.label}
      backgroundColor={config.bg}
      textColor={config.text}
    />
  );
};

export default NocStatusIndicator;
